var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlechaEsquema(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "37px",
    viewBox: "0 0 32 37",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 12.3486 0 12.3486 12.434 0 12.434"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols-DIC",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "elementos-/-flecha",
    transform: "translate(-1, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(2.4558, -0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.18435867,37.0169836 C8.18435867,26.7819836 9.44035867,16.8399836 11.8063587,7.33698361",
    id: "Stroke-1",
    stroke: "#000000",
    strokeWidth: 1.716,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(9.9954, 22.177) rotate(35) translate(-9.9954, -22.177)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(21.1449, 8.6341) rotate(35) translate(-21.1449, -8.6341)translate(14.9706, 2.4171)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-4"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    fill: "#000000",
    mask: "url(#mask-2)",
    points: "12.3486 12.434 9.1906 0 -0.0004 8.952"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlechaEsquema);
export default __webpack_public_path__ + "static/media/flecha-esquema.9e3a72644b953045bfbdfa02c63b0ed5.svg";
export { ForwardRef as ReactComponent };